import Head from 'next/head'
import type {FC} from 'react'
import type {ArticleStructuredData, FaqStructuredData} from '../utils'
import {sanitizeJsonLd} from '../utils'

type ArticleSEOProps = {
  structuredData: ArticleStructuredData | null
  faqStructuredData?: FaqStructuredData | null
}

export const ArticleSEO: FC<ArticleSEOProps> = ({structuredData, faqStructuredData}) => {
  if (!structuredData && !faqStructuredData) {
    return null
  }

  return (
    <Head>
      {structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{__html: sanitizeJsonLd(structuredData)}}
          key="article-structured-data"
        />
      )}
      {faqStructuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{__html: sanitizeJsonLd(faqStructuredData)}}
          key="blogpost-faq-structured-data"
        />
      )}
    </Head>
  )
}
